import { render, staticRenderFns } from "./ProjectNewButton.vue?vue&type=template&id=45d15af6&scoped=true&"
import script from "./ProjectNewButton.vue?vue&type=script&lang=ts&"
export * from "./ProjectNewButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectNewButton.vue?vue&type=style&index=0&id=45d15af6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d15af6",
  null
  
)

export default component.exports